<template>
  <div>
    <div class="container">
      <h1 class="welcome-text">Welcome to</h1>
      <div class="logo-text">
        <h1 class="main-text">Track me</h1>
        <img src="../assets/logo.svg" alt="">
      </div>
      <div>
      <button class="start-btn" @click="start"> Get Started</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    start () {
      this.$router.push('/signup')
    }
  }
}
</script>
<style scoped>
.logo-text {
  display: inline-flex;
  align-items: center;
}
.container {
  display: block;
  justify-content: center;
  height: 100%
}
.main-text {
  font-weight: 700;
  font-size: 64px;
  line-height: 96px;
  margin: 0 14px 0 0;
}
.start-btn{
  width: 139px;
  height: 52px;
  margin-top: 83px;
  background: linear-gradient(96.18deg, #03A3F5 -5.4%, #B983FF 50.72%, #FFE883 85.14%);
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  border: 0px;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #FFFFFF;
  cursor: pointer;
}
.welcome-text{
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  /* display: flex; */
  align-items: center;

  color: #1F1F1F;

}
</style>
